import { Component, HostBinding, OnInit, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { ApplicationService } from '../application-service/application.service';
import { StorageService } from '../storage-service/storage.service';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core'

@Component({
    selector: 'home', // tslint:disable-line
    templateUrl: './home.component.html',
    styleUrls: ['../../assets/theme/css/Home.css']
})
export class HomeComponent implements OnInit, OnDestroy {
    @HostBinding() class = 'flex-container-v nowrap h100';

    private languageChange: Subscription;

    constructor(
        private _application: ApplicationService,
        private _title: Title,
        private _storage: StorageService,
        private _translate: TranslateService,
    ) { }

    ngOnInit(): void {
        this._application.retrieveAndMergeDictionnaries(this._application.getLanguage());

        // when current language changes, load the models translations provided by oxe
        this.languageChange = this._translate.onLangChange.subscribe((event: LangChangeEvent) => {
            this._application.retrieveAndMergeDictionnaries(event.lang);
        });

        // set the title of page
        this._title.setTitle('OXE ' + this._storage.getHost());
    }

    /**
     * Cleanup just before Angular destroys the directive/component.
     * Prevents memory leak when component is destroyed.
     */
    ngOnDestroy(): void {
        // Unsubscribe observables and detach event handlers to avoid memory leaks.
        this.languageChange.unsubscribe();
    }
}
